/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmAutomationFilter extends models.AwsSsmExecutionFilter {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmAutomationFilter");
    }

    getFixupPrototypeFunction() { return AwsSsmAutomationFilter.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmAutomationFilter>): AwsSsmAutomationFilter {
        let obj = Object.assign(new AwsSsmAutomationFilter(), model);
        AwsSsmAutomationFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmAutomationFilter>): AwsSsmAutomationFilter {
        if (!model) return null;
        return AwsSsmAutomationFilter.newInstance(<AwsSsmAutomationFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmAutomationFilter) {
        if (!obj) return;

        models.AwsSsmAutomationFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmAutomationFilter): boolean {
        if (models.AwsSsmExecutionFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmAutomationFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Status of the Automation Execution
     */
    status: models.AwsSsmAutomationExecutionStatus;

}
